import { render } from "./index.vue?vue&type=template&id=e567a74a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=e567a74a&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e567a74a"],['__file',"src/views/game/task/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e567a74a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e567a74a', __exports__)) {
    console.log('reload')
    api.reload('e567a74a', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=e567a74a&scoped=true", () => {
    console.log('re-render')
    api.rerender('e567a74a', render)
  })

}


export default __exports__